module.exports = __webpack_public_path__ + "media/images/checkout/challenger/eye-13fd55cd04e81a8153984b0a0b1a3fb2.svg";